import { Link, useNavigate } from "react-router-dom";
import React, { useEffect } from "react";
import "./Logout.css";

import Header from "../../../Components/Header";
import PriceBar from "../../../Components/PriceBar/";
import Footer from "../../../Components/Footer/";

import { useDispatch } from "react-redux";
import { logout } from "../../../Features/Session/SessionSlice";
import { resetUserState } from "../../../Features/User/UserSlice"; // Import this
import { useSelector } from "react-redux";

function Logout() {
  const labels = useSelector((state) => state.labels.data);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    // Clear all localStorage
    localStorage.removeItem("token");
    localStorage.removeItem("userInfo");
    localStorage.removeItem("initialPrices");

    // Reset Redux states
    dispatch(logout());
    dispatch(resetUserState()); // Clear user authentication state

    // Brief delay to show logout message, then redirect
    const timer = setTimeout(() => {
      navigate("/login", { replace: true });
    }, 1500);

    return () => clearTimeout(timer);
  }, [dispatch, navigate]);

  return (
    <>
      <Header />
      <PriceBar />

      <div className="row">
        <div className="d-flex justify-content-center">
          <h1 style={{ color: "#aaa", paddingTop: 55 }}>
            {labels?.messages?.successfulLogout}
          </h1>
        </div>
        <div className="d-flex justify-content-center">
          <h4 style={{ color: "#aaa", paddingTop: 55 }}>
            <Link to="/login">{labels?.navbar?.links?.login}</Link>
          </h4>
        </div>
        <p>
          <br />
          <br />
        </p>
      </div>
      <Footer />
    </>
  );
}

export default Logout;
